// import vuex from "vuex"
const net = {
  url: localStorage.getItem("net"),
};

export default net;
